import { Component, OnInit } from '@angular/core';
import { KamonaIdVerificationComponent } from '../../kamona-id-verification.component';
import { UtilityService } from '../../../../../core/services/utility.service';

@Component({
    selector: 'app-mobile-kamona-id-verification',
    templateUrl: './mobile-kamona-id-verification.component.html',
    styleUrls: ['./mobile-kamona-id-verification.component.scss'],
})
export class MobileKamonaIdVerificationComponent extends KamonaIdVerificationComponent implements OnInit {
    constructor(utility: UtilityService) {
        super(utility);
    }

    ngOnInit(): void {
        this.showModal();
        this.initialize();
    }
}
